var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"01e81b7d84d8480738a04c7566f92d1b6aaf1ab7"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/main";

// All client side configuration is stood up on top of application event consumption.
// The only reason this file exists is because of the unflexible Sentry API(They puke without it).
export {};
